import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Globals } from 'src/shared/globals';

@Injectable({
    providedIn: 'root'
})
export class SinglePropertyPageService {
    url = `${this.global.apiUrl}Property/`;
    constructor(private httpService: HttpClient, private global: Globals) {
    }

    public GetPropertyDetailsByUrl(propertyUrl: any): Observable<any> {
      return this.httpService.get(this.url + 'GetPropertyDetailsByUrl?propertyUrl=' + propertyUrl);
  }
}
